import { Box, InputBase, Modal, Popover, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import CloseIcon from "../../../assets/SVG/closeIcon";
import ShowLevelPop from "../../leaderGroup/showLevelPop";
import LevelFiveArea from "./levelFiveArea";
import LevelFourArea from "./levelFourArea";
import LevelOneArea from "./levelOneArea";
import LevelThreeArea from "./levelThreeArea";
import LevelTwoArea from "./levelTwoArea";
import socialMedia from "../../../assets/image/socialMedia.png";
import { CheckBoxBranch } from "../../signin/chekboxListBranch";
import {
  getEquipmentManagers,
  getgetDispatchers,
  getInsurancers,
  getManage_user,
  getModulesInArea,
  getPharmacyManagers,
  getRunInfoArea,
  getTrainers,
  sendTripAlarmToAllMembers,
} from "../../../api/area";

export default function CreateAreaPop({
  anchorEl,
  setAnchorEl,
  areaId,
  update,
}) {
  const [level, setLevel] = useState(1);
  const [levelLocal, setLevelLocal] = useState();
  const [date, setDate] = useState();

  const [dataLoc, setDataLoc] = useState({
    countries: { name: "" },
    states: { name: "" },
    cities: { name: "" },
  });
  const [stepOne, setStepOne] = useState({
    cityId: "",
    startAt: 0,
    endAt: 0,
    dailyStartAt: "",
    dailyEndAt: "",
    lat: 35.55,
    lng: 33.33,
  });

  const [dataUserSelected, setDataUserSelected] = useState([]);
  const [moduleSelected, setModuleSelected] = useState([]);

  const [dataMsg, setDataMsg] = useState({
    msg: "",
    sendSMS: true,
    sendNotif: true,
  });

  const dataLevel = [
    { number: 1, blueText: "منطقه", grayText: "انتخاب محل اردو و زمان" },
    {
      number: 2,
      blueText: "جهادگران",
      grayText: "انتخاب جهادگر اردو",
    },
    {
      number: 3,
      blueText: "بخش‌ها",
      grayText: "انتخاب بخش‌های اردو",
    },
    {
      number: 4,
      blueText: "وظیفه",
      grayText: "انتخاب وظیفه جهادگران",
    },
    {
      number: 5,
      blueText: "آموزش",
      grayText: "انتخاب آموزشگر",
    },
    {
      number: 6,
      blueText: "پذیرش",
      grayText: "انتخاب پذیرشگر",
    },
    {
      number: 7,
      blueText: "بیمه گر",
      grayText: "انتخاب بیمه گر",
    },
    {
      number: 8,
      blueText: "مسئول داروخانه",
      grayText: "انتخاب مسئول داروخانه",
    },
    {
      number: 9,
      blueText: "مسئول تجهیزات",
      grayText: "انتخاب مسئول تجهیزات",
    },
  ];

  const handleClose = () => {
    setAnchorEl(null);
    // setOpenPopover(false);
    // setDate();
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const [show, setShow] = useState(false);
  const handleOpen = () => setShow(true);
  const handleClose1 = () => {
    setShow(false);
  };
  useEffect(() => {
    if (open) {
      if (areaId) {
        if (level === 1) {
          getRunInfoArea(areaId)
            .then((x) => {
              setStepOne(x);
            })
            .catch(() => {});
        }
        if (level === 2) {
          getManage_user(areaId)
            .then((x) => setDataUserSelected(x))
            .catch(() => {});
        }
        // if (level === 3) {
        //   getModulesInArea(areaId)
        //     .then((x) => setModuleSelected(x))
        //     .catch(() => {});
        // }
        if (level === 5) {
          getTrainers(areaId)
            .then((x) => setDataUserSelected(x))
            .catch(() => {});
        }
        if (level === 6) {
          getgetDispatchers(areaId)
            .then((x) => setDataUserSelected(x))
            .catch(() => {});
        }
        if (level === 7) {
          getInsurancers(areaId)
            .then((x) => setDataUserSelected(x))
            .catch(() => {});
        }
        if (level === 8) {
          getPharmacyManagers(areaId)
            .then((x) => setDataUserSelected(x))
            .catch(() => {});
        }
        if (level === 9) {
          getEquipmentManagers(areaId)
            .then((x) => setDataUserSelected(x))
            .catch(() => {});
        }
      }
    }
  }, [open, level]);
  // console.log(stepOne);
  useEffect(() => {
    const items = JSON.parse(localStorage.getItem("levelPopArea"));
    if (items === 1) {
      setLevel(1);
    }
    if (items === 2) {
      setLevel(2);
    }
    if (items === 3) {
      setLevel(3);
    }
    if (items === 4) {
      setLevel(4);
    }
    if (items === 5) {
      setLevel(5);
    }
    if (items === 6) {
      setLevel(6);
    }
    if (items === 7) {
      setLevel(7);
    }
    if (items === 8) {
      setLevel(8);
    }
  }, []);
  console.log(stepOne);
  return (
    <>
      <Popover
        sx={{
          "& .MuiPaper-root": {
            width: "92vw",
            height: "80vh",
            padding: "22px 23px",
            borderRadius: "13px",
          },
          "& .MuiBackdrop-root": {
            backgroundColor: "#00000060",
          },
        }}
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <Box>
          <Box
            width="fit-content"
            sx={{ cursor: "pointer" }}
            onClick={handleClose}
          >
            {" "}
            <CloseIcon />{" "}
          </Box>
          <Box display="flex" gap="30px" alignItems={"center"}>
            <Box width="80%">
              {level === 1 && (
                <LevelOneArea
                  update={update}
                  areaId={areaId}
                  setDataLoc={setDataLoc}
                  dataLoc={dataLoc}
                  setStepOne={setStepOne}
                  stepOne={stepOne}
                  setLevel={setLevel}
                  date={date}
                  setDate={setDate}
                />
              )}
              {level === 2 && (
                <LevelTwoArea
                  update={update}
                  areaId={areaId}
                  setDataUserSelected={setDataUserSelected}
                  dataUserSelected={dataUserSelected}
                  setLevel={setLevel}
                  level={level}
                />
              )}
              {level === 3 && (
                <LevelThreeArea
                  update={update}
                  setModuleSelected={setModuleSelected}
                  moduleSelected={moduleSelected}
                  areaId={areaId}
                  setLevel={setLevel}
                  level={level}
                />
              )}
              {level === 4 && (
                <LevelFourArea
                  areaId={areaId}
                  setLevel={setLevel}
                  level={level}
                />
              )}
              {level === 5 && (
                <LevelTwoArea
                  areaId={areaId}
                  setDataUserSelected={setDataUserSelected}
                  dataUserSelected={dataUserSelected}
                  setLevel={setLevel}
                  level={level}
                />
              )}
              {level === 6 && (
                <LevelTwoArea
                  areaId={areaId}
                  setDataUserSelected={setDataUserSelected}
                  dataUserSelected={dataUserSelected}
                  setLevel={setLevel}
                  level={level}
                />
              )}
              {level === 7 && (
                <LevelTwoArea
                  areaId={areaId}
                  setDataUserSelected={setDataUserSelected}
                  dataUserSelected={dataUserSelected}
                  setLevel={setLevel}
                  level={level}
                />
              )}
              {level === 8 && (
                <LevelTwoArea
                  areaId={areaId}
                  setDataUserSelected={setDataUserSelected}
                  dataUserSelected={dataUserSelected}
                  setLevel={setLevel}
                  level={level}
                />
              )}
              {level === 9 && (
                <LevelTwoArea
                  areaId={areaId}
                  setDataUserSelected={setDataUserSelected}
                  dataUserSelected={dataUserSelected}
                  setLevel={setLevel}
                  level={level}
                  handleOpen={handleOpen}
                  handleClose={handleClose}
                />
              )}
            </Box>
            <Box width="30%">
              <ShowLevelPop
                height={"70vh"}
                dataLevel={dataLevel}
                level={level}
              />
            </Box>
          </Box>
        </Box>
      </Popover>
      <Modal
        open={show}
        onClose={handleClose1}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        //   sx={{}}
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 750,
            height: 350,
            bgcolor: "white",
            boxShadow: 24,
            p: 5,
            borderRadius: "23px",
            ":focus-visible": {
              outline: "none !important",
              border: "none !important",
            },
          }}
        >
          <Box display="flex" alignItems="center" gap="20px">
            <Box width="40%" borderLeft="1px solid #98C2CB" height={"350px"}>
              <img src={socialMedia} />
            </Box>
            <Box height="300px" pl="20px">
              <Box>
                <Typography fontSize="18px">{"اطلاع رسانی"}</Typography>
                <Typography
                  mt="10px"
                  color="var(--emr-disable)"
                  fontSize="16px"
                >
                  {
                    "لطفاً روش اطلاع‌رسانی را برای جهادگران انتخاب نموده و محتوای پیام را وارد نمایید."
                  }
                </Typography>
              </Box>
              <Box my="20px">
                <Typography my="10px">پیام</Typography>
                <InputBase
                  onChange={(e) =>
                    setDataMsg({ ...dataMsg, msg: e.target.value })
                  }
                  value={dataMsg.msg}
                  placeholder="پیامی برای جهادگران بنویسید."
                  sx={{
                    border: "solid 1px var(--emr-borderInput)",
                    borderRadius: "8px",
                    width: "100%",
                    px: "10px",
                    bgcolor: "#F3F3F3",
                  }}
                />
              </Box>
              <CheckBoxBranch
                onChange={(e) =>
                  setDataMsg({ ...dataMsg, sendSMS: e.target.checked })
                }
                checked={dataMsg.sendSMS}
                label="اطلاع رسانی از طریق پیامک"
              />
              <Box mt="-20px">
                <CheckBoxBranch
                  onChange={(e) =>
                    setDataMsg({ ...dataMsg, sendNotif: e.target.checked })
                  }
                  checked={dataMsg.sendNotif}
                  label="اطلاع رسانی از طریق نرم افزار"
                />
              </Box>
              <button
                onClick={() => {
                  sendTripAlarmToAllMembers(areaId, dataMsg)
                    .then(() => {
                      setShow(false);
                    })
                    .catch(() => {});
                }}
                style={{
                  borderRadius: "7px",
                  background: "var(--emr-darkblue)",
                  border: "none",
                  padding: "10px 0px",
                  marginTop: "5px",
                  fontSize: "20px",
                  color: "white",
                  width: "100%",
                }}
              >
                {"ارسال پیام و ایجاد"}
              </button>
            </Box>
          </Box>
        </Box>
      </Modal>
    </>
  );
}
